module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: {
      active: _vm.sidebarActiveButton === 'steps'
    },
    attrs: {
      "title": _vm.$t('general.labels.steps')
    },
    on: {
      "click": function($event) {
        _vm.sidebarChangePanel('steps');
        _vm.sidebarChangeActiveButton('steps');
        _vm.canvasChangeView('steps')
      }
    }
  }, [_c('i', {
    staticClass: "kp-panel-question"
  })])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-33710fdc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/buttons/types/Steps.vue
 ** module id = 796
 ** module chunks = 1
 **/